import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';

const SkeletonColumn = styled.div`
  width: 300px;
  margin: 0 8px;
  padding: 16px;
  background: #f5f5f5;
  border-radius: 4px;
`;

const SkeletonCard = styled.div`
  margin-bottom: 16px;
  padding: 16px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
`;

const SkeletonContainer = styled.div`
  display: flex;
  padding: 16px;
  overflow-x: auto;
  gap: 8px;
`;

const ColumnsSkeleton = () => (
  <SkeletonContainer>
    {[1, 2, 3, 4, 5].map((column) => (
      <SkeletonColumn key={column}>
        <Skeleton active paragraph={{ rows: 0 }} />
        {[1, 2, 3, 4, 5].map((card) => (
          <SkeletonCard key={card}>
            <Skeleton active paragraph={{ rows: 2 }} />
          </SkeletonCard>
        ))}
      </SkeletonColumn>
    ))}
  </SkeletonContainer>
);

export default ColumnsSkeleton; 